import { Button } from "@omni/ui/components/Button/button.component";
import { cn } from "@omni/utils/styles";

import { useClickAndCollectContext } from "@/components/Product/ECommerce/components/delivery/components/deliveryTypes/deliveryItem/components/clickAndCollect/context/clickAndCollect.context";
import { useDeliveryItemContext } from "@/components/Product/ECommerce/components/delivery/components/deliveryTypes/deliveryItem/context/deliveryItem.context";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

type Props = {
    className?: string;
    hide?: boolean;
};

export const StorePickerButton = ({ className, hide }: Props) => {
    const { t } = useGranite();

    const { setIsStorePickerOpen } = useClickAndCollectContext();

    const { isBoxArticle, onChangeDeliveryType } = useDeliveryItemContext();

    if (hide) {
        return null;
    }

    return (
        <Button
            color={"link"}
            className={cn("tw:mt-2 tw:p-0", className)}
            type="button"
            onClick={() => {
                onChangeDeliveryType();
                setIsStorePickerOpen(true);
            }}
        >
            {t(
                isBoxArticle
                    ? "general.ecommerce.link.box.showStores"
                    : "general.ecommerce.link.showAvailability"
            )}
            <i className={cn("las la-angle-right", "tw:mr-1")} />
        </Button>
    );
};
